export default "__VITE_ASSET__ca62b361__"